import { render, staticRenderFns } from "./ProductionProgressionCard.vue?vue&type=template&id=623b897a&scoped=true"
import script from "./ProductionProgressionCard.vue?vue&type=script&lang=js"
export * from "./ProductionProgressionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b897a",
  null
  
)

export default component.exports